exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_authors_1HKAln1GGjqcg1FCiAI25u {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 40px;\n  margin-block-end: 1em;\n}\n\n.IA_expandButton_3lJCCvKP6glv3waR-jDBlc {\n  float: right;\n  height: 40px;\n  width: 50px;\n  text-align: right;\n  line-height: 40px;\n  cursor: pointer;\n}\n\n.IA_expandedContent_3TDtQXXctMxHjnJ4lVpaIh {\n  border-bottom: 1px solid #eeeeee;\n  float: left;\n  height: auto;\n  width: 100%;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_authors": "IA_authors_1HKAln1GGjqcg1FCiAI25u",
	"IA_expandButton": "IA_expandButton_3lJCCvKP6glv3waR-jDBlc",
	"IA_expandedContent": "IA_expandedContent_3TDtQXXctMxHjnJ4lVpaIh"
};